import { defineStore } from 'pinia'
import axios from 'axios'
import { loginRedirects } from '../lib/loginRedirect.js'
export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
    previous_user: null,
    intended_url: null,
    pendingLoginRedirect: null,
    suppressLoginRedirect: false,
  }),
  actions: {
    set_user(user) {
      this.user = user
    },
    set_intended_url(intendedUrl) {
      this.intended_url = intendedUrl
    },
    async attempt_user() {
      try {
        const { data } = await axios.get('/api/v1/me')

        this.user = data.current_user
        this.previous_user = data.previous_user || null
        return data.current_user
      }
      catch(e) {
        this.user = null
      }
    },
    async logout() {
      return axios.post('/logout')
        .then((response) => {
          this.router.push('/')
          this.$reset()
        })
        .catch((error) => {
          console.error(error)
          throw error
        })
    },
    async loginViaToken(token) {
      this.pendingLoginRedirect = null
      this.suppressLoginRedirect = false
      await axios.get('/sanctum/csrf-cookie');
      const loginResponse = await axios.post('/api/login-via-token', {token:token})
      if (loginResponse?.status === 200 && loginResponse.data?.two_factor) {
        await this.router.push({ name: 'TwoFactorChallenge' })
        return
      }
      await this.attempt_user()
      await this.redirectAfterLogin()
    },
    async login(payload, noRedirect) {
      this.pendingLoginRedirect = payload.redirect_to ?? null
      this.suppressLoginRedirect = !!noRedirect
      await axios.get('/sanctum/csrf-cookie');
      const loginResponse = await axios.post('/login', payload)

      if (loginResponse?.status === 200 && loginResponse.data?.two_factor) {
        await this.router.push({ name: 'TwoFactorChallenge' })
        return
      }
      await this.attempt_user()
      await this.redirectAfterLogin()
    },
    async completeTwoFactorLogin(payload) {
      await axios.post('/two-factor-challenge', payload)
      await this.attempt_user()
      await this.redirectAfterLogin()
    },
    async redirectAfterLogin() {
      if (!this.user) {
        return
      }

      const destination = this.pendingLoginRedirect || this.intended_url
      if (destination || !this.suppressLoginRedirect) {
        await this.router.push(destination || this.loginDestination)
      }
      this.pendingLoginRedirect = null
      this.intended_url = null
      this.suppressLoginRedirect = false
    },
    async startImpersonation(userId) {
      const { data } = await axios.post(`/api/v1/impersonate/${userId}`,{
        source_url: this.router.currentRoute.value.fullPath
      })
      this.user = data.user
      this.previous_user = data.previous_user || null
      await this.attempt_user()
    },
    async stopImpersonation() {
      const { data } = await axios.post(`/api/v1/impersonate-stop`)
      this.previous_user = null
      this.user = data.user
      if(data.original_url_source) {
        await this.router.push(data.original_url_source)
      }
    }
  },
  getters: {
    loginDestination: state => loginRedirects.resolve(state.user),
    currentUser: (state) => state.user,
    previousUser: (state) => state.previous_user,
    hasPermission: (state) => (permission) => {
      if (!state.user || !state.user.permissions_cached) {
        return false;
      }
      return state.user.permissions_cached.includes(permission);
    }
  },
})
